import { render, staticRenderFns } from "./Hosteleria.vue?vue&type=template&id=6aa4ba09&scoped=true&"
import script from "./Hosteleria.vue?vue&type=script&lang=js&"
export * from "./Hosteleria.vue?vue&type=script&lang=js&"
import style0 from "./Hosteleria.vue?vue&type=style&index=0&id=6aa4ba09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa4ba09",
  null
  
)

export default component.exports